module.exports = __webpack_public_path__ + "img/news.06d6769d.png";